import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnChanges, OnInit, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import {Company, ConnectionService } from '../../services/Connection/connection.service';
import { ScrollService } from '../../services/Scroll/scroll.service';
import { SharedService } from '../../services/shared/shared.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CacheService } from '../../services/Cache/cache.service';
import { EventsService } from '../../services/events/events.service';
import { Categorias } from 'src/app/shared/Interfaces/company';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css'
})
export class TopBarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('listBar') listBar!: ElementRef
  @ViewChild('topBar') topBar!: ElementRef;

  @ViewChildren('navlink') navlinksTop!: QueryList<ElementRef>;
  @ViewChildren('bar') barTop!: QueryList<ElementRef>;

  @Input() sections!: QueryList<ElementRef>
  @Input() verifiScrolling!: boolean;
  @Input() tabela!: Categorias[];

  private startTime!: number;
  private scrollTimeout: any;
  scrollTopPosition: number = 0;
  fixedbar = false;
  cachePosition: number = 0;
  scrollIndex: number = 0;
  scrollPosition: number = 0;
  filter: string = '';
  sectionPositions: number[] = [];
  currentSectionIndex = 0;
  barra = false;
  pauseFunctions = false;
  company!: Company;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktop: boolean = false;

  private scrollPositionSubscription!: Subscription;
  private scrollIndexSubscription!: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private connection: ConnectionService,
    private eventService: EventsService,
    private scrollService: ScrollService,
    private sharedService: SharedService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private cacheService: CacheService
  ){
  }

  ngOnInit(): void {
    this.sharedService.filter$.subscribe((newValue) => {
      this.filter = newValue;
    });
    this.connection.company$.subscribe((newCompany) =>{
      this.company = newCompany;
      if(this.company)
        this.alterationTopBar()
        this.cdr.detectChanges();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  getDynamicClasses() {
    const dynamicClasses: { [key: string]: boolean } = {
      'active-bar': this.barra
    };

    if (this.barra && this.company.configs.colorCompany) {
      dynamicClasses[`active-bar.${this.company.configs.colorCompany}`] = true;
    }

    return dynamicClasses;
  }

  ngAfterViewInit(): void {
    if (this.verifiScrolling) {
      this.scroll();
    }
    else{

      setTimeout(() => {
        window.scrollTo({
          behavior: 'instant' as ScrollBehavior,
          top: 0,
          left: 0
        });
      }, 1000);


      setTimeout(() => {
        this.colorBar(0);
        this.calculateSectionPositions();
      }, 2000);
    }
  }

  ngOnDestroy(): void {
    const index = this.findCurrentSectionIndex(window.scrollY);
    this.scrollService.setScrollPosition(window.scrollY);
    this.scrollService.setScrollIndex(index);
    this.scrollService.scrollingSubject.next(true);
    this.cacheService.setItemSession('index', index);

  }

  scroll(){
    this.cachePosition = this.scrollService.getScrollPosition();
    this.scrollPosition = this.scrollService.getScrollIndex();

    setTimeout(() => {
      window.scrollTo({
        behavior: 'instant' as ScrollBehavior,
        top: this.cachePosition,
        left: 0
      });
    }, 10);
    
    setTimeout(() => {
      this.colorBar(this.scrollPosition);
    });

    this.pauseFunctions = true;
  }

  calculateSectionPositions() {
    // Assuma que você tem uma lista de seções no seu componente
    this.sections.forEach(section => {
      if (section && section.nativeElement) {

        this.sectionPositions.push(section.nativeElement.offsetTop - 110);
      }
    });
  }

  scrollToSection(sectionId: number): void{

    if(this.sectionPositions.length == 0){
      this.calculateSectionPositions();
    }

    if(sectionId != 0){
      window.scrollTo({top: this.sectionPositions[Number(sectionId)], behavior: 'auto'});
    }
    else{
      window.scrollTo({top: 0, behavior: 'auto'});
    }


    this.pauseFunctions = true;
    this.colorBar(Number(sectionId))

  }

  //Cores do menu de navegação superior
  colorBar(currentSectionIndex: number){

    this.navlinksTop.forEach((link: ElementRef) => {
      this.renderer.removeClass(link.nativeElement, 'active-nav-top');
    });

    this.barTop.forEach((bar: ElementRef) => {
      this.renderer.removeClass(bar.nativeElement, 'active-bar');
    });

    const navLink = this.navlinksTop.toArray()[currentSectionIndex];
    const bar = this.barTop.toArray()[currentSectionIndex];

    if (navLink && bar) {
      this.renderer.addClass(navLink.nativeElement, 'active-nav-top');
      this.renderer.addClass(bar.nativeElement, 'active-bar');
    }

    this.scrollToNavLink(currentSectionIndex);

  }

  /*Responsavel por dar o scroll no menu superior*/
  scrollToNavLink(index: number) {
    const navlinksTop = this.elementRef.nativeElement.querySelectorAll('.top-bar ul li span');
    const topbar = this.listBar.nativeElement as HTMLElement;
    if (topbar && navlinksTop[index]) {
      const navlinkRect = navlinksTop[index].getBoundingClientRect();
      const navlinkMiddleFromTopBarStart = navlinkRect.left - topbar.getBoundingClientRect().left + navlinkRect.width / 2;
      const containerMiddle = topbar.clientWidth / 2;
      const scrollPosition = navlinkMiddleFromTopBarStart - containerMiddle + topbar.scrollLeft;
      topbar.scrollLeft = scrollPosition;
    }
  }

  //Procura o index das categorias pela posição
  findCurrentSectionIndex(currentScrollY: number): number {
    if(this.sectionPositions.length != 0){
      for (let i = this.sectionPositions.length - 1; i >= 0; i--) {
        if (currentScrollY >= this.sectionPositions[i] - 85) {
          return i;
        }
      }
    }
    else{
      const sectionArray = this.sections.toArray();

      for (let i = sectionArray.length - 1; i >= 0; i--) {
        if (currentScrollY >= sectionArray[i].nativeElement.offsetTop - 85) {
          return i;
        }
      }
    }
    return 0;
  }

  alterationTopBar(): void{
    
    this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    //Mobile
    if(window.innerWidth <= 846)
    {
      this.isTablet = false;
      this.isDesktop = false;
      this.isMobile = true;

      if(this.company.configs.closeScheduling == 1){
        if(this.scrollTopPosition >= 300)
        {
          this.fixedbar = true
        }
        else if(this.scrollTopPosition <= 300){
          this.fixedbar = false
        }
      }
      else{
        if(this.scrollTopPosition >= 300)
        {
          this.fixedbar = true
        }
        else if(this.scrollTopPosition <= 300){
          this.fixedbar = false
        }
      }


    }
    //Tablet
    else if(window.innerWidth >= 846 && window.innerWidth <= 1168)
    {
      this.isMobile = false;
      this.isDesktop = false;
      this.isTablet = true;
      
    }
    //Desktop
    else{
      this.isDesktop = true;
      this.isMobile = false;
      this.isTablet = false;
    }
  }

  private isScrolledToBottom(): boolean {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;

    return windowBottom >= docHeight;
  }

  // Ação a ser executada quando a orientação do dispositivo for alterada
  onOrientationChange(event: Event): void {
    // if (window.matchMedia("(orientation: portrait)").matches) {
    //   //vertical
    //   this.alterationTopBar();
    // } else {
    //   //horizontal
    //   this.alterationTopBar();
    // }
  }

  @HostListener('window:scroll', [])
  onScroll(): boolean  {
    clearTimeout(this.scrollTimeout);
    const scrollY = window.scrollY;


    if(!this.pauseFunctions)
    {
      const newSectionIndex: number = this.findCurrentSectionIndex(scrollY);
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (newSectionIndex != this.currentSectionIndex) {
        this.currentSectionIndex = newSectionIndex;
        if(this.scrollTopPosition <= 195){
          this.colorBar(0);
        }
        else{
          this.colorBar(newSectionIndex);
        }

      }
      else{
        if (this.isScrolledToBottom()) {
          const number = this.sectionPositions.length - 1;
          this.colorBar(number)
        }
        else{
          this.colorBar(newSectionIndex)
        }
      }
    }

    this.scrollTimeout = setTimeout(() => {
      this.handleScrollEnd();
    }, 100);

    this.alterationTopBar();

    return false;
  }

  @HostListener('window:resize', [])
  onSize(): boolean  {

    this.alterationTopBar();

    return false;
  }

  private handleScrollEnd(): void {
    this.startTime = 0;
    setTimeout(() => {
      this.pauseFunctions = false;
    }, 100);

  }
}
